import type { ArcanaReadingQueueItemDto } from '@lunary/api-client'
import { errorText } from './labels'
import { useReadingActions } from './queries'
import styles from './readings.module.css'

export function CloseOfferButton({ reading }: { reading: ArcanaReadingQueueItemDto }) {
  const actions = useReadingActions(reading.id)
  const busy = actions.close.isPending || actions.offerUpgrade.isPending || actions.cancelUpgrade.isPending
  const error = actions.close.error ?? actions.offerUpgrade.error ?? actions.cancelUpgrade.error
  if (reading.status !== 'ready' && reading.status !== 'clarifying') return null
  return (
    <>
      {reading.format === 'question' &&
        (reading.upgrade_offered ? (
          <>
            <span className={styles.offerFlag}>Человек видит предложение консультации</span>
            <button type="button" className="secondary" disabled={busy} onClick={() => actions.cancelUpgrade.mutate()}>
              Отменить
            </button>
          </>
        ) : (
          <button
            type="button"
            className="secondary"
            disabled={busy}
            title="Человек увидит доплату до консультации, чат останется тем же"
            onClick={() => actions.offerUpgrade.mutate()}
          >
            {actions.offerUpgrade.isPending ? 'Отправляю…' : 'Предложить консультацию'}
          </button>
        ))}
      <button
        type="button"
        className="secondary"
        disabled={busy}
        title="Чат закроется, человеку придёт уведомление"
        onClick={() => {
          if (window.confirm('Завершить разбор? Написать в него больше будет нельзя.')) actions.close.mutate()
        }}
      >
        {actions.close.isPending ? 'Завершаю…' : 'Завершить разбор'}
      </button>
      {error && <span className="error-box">{errorText(error)}</span>}
    </>
  )
}
